import { globalConfig } from '@/globalConfig';

export function persistRequestId(requestId: number): void {
  window.localStorage.setItem(
    globalConfig.storage.requestId,
    String(requestId)
  );
}
